import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "\u0626\u06C7\u064A\u063A\u06C7\u0631\u0686\u06D5",
  code: "ug-CN",
  dir: "rtl",
  messages: {
    alert: {
      close: "\u062A\u0627\u0642\u0627\u0634"
    },
    authForm: {
      hidePassword: "\u067E\u0627\u0631\u0648\u0644\u0646\u0649 \u064A\u0648\u0634\u06C7\u0631\u06C7\u0634",
      showPassword: "\u067E\u0627\u0631\u0648\u0644\u0646\u0649 \u0643\u06C6\u0631\u0633\u0649\u062A\u0649\u0634",
      submit: "\u062F\u06D5\u06CB\u0627\u0645 \u0642\u0649\u0644\u0649\u0634"
    },
    banner: {
      close: "\u062A\u0627\u0642\u0627\u0634"
    },
    calendar: {
      nextMonth: "\u0643\u06D0\u0644\u06D5\u0631 \u0626\u0627\u064A",
      nextYear: "\u0643\u06D0\u0644\u06D5\u0631 \u064A\u0649\u0644",
      prevMonth: "\u0626\u0627\u0644\u062F\u0649\u0646\u0642\u0649 \u0626\u0627\u064A",
      prevYear: "\u0626\u0627\u0644\u062F\u0649\u0646\u0642\u0649 \u064A\u0649\u0644"
    },
    carousel: {
      dots: "\u0643\u06C6\u0631\u0633\u0649\u062A\u0649\u062F\u0649\u063A\u0627\u0646 \u0633\u0644\u0627\u064A\u062F\u0646\u0649 \u062A\u0627\u0644\u0644\u0627\u06AD",
      goto: "{slide}-\u0628\u06D5\u062A\u0643\u06D5 \u0626\u0627\u062A\u0644\u0627\u0634",
      next: "\u0643\u06D0\u064A\u0649\u0646\u0643\u0649 \u0628\u06D5\u062A",
      prev: "\u0626\u0627\u0644\u062F\u0649\u0646\u0642\u0649 \u0628\u06D5\u062A"
    },
    chatPrompt: {
      placeholder: "\u062E\u06D5\u062A \u0643\u0649\u0631\u06AF\u06C8\u0632\u06C8\u06AD..."
    },
    chatPromptSubmit: {
      label: "\u064A\u0648\u0644\u0644\u0627\u0634"
    },
    colorMode: {
      dark: "\u0642\u0627\u0631\u0627\u06AD\u063A\u06C7",
      light: "\u064A\u0648\u0631\u06C7\u0642",
      switchToDark: "\u0642\u0627\u0631\u0627\u06AD\u063A\u06C7 \u06BE\u0627\u0644\u06D5\u062A\u0643\u06D5 \u0626\u0627\u0644\u0645\u0627\u0634\u062A\u06C7\u0631\u06C7\u0634",
      switchToLight: "\u064A\u0648\u0631\u06C7\u0642 \u06BE\u0627\u0644\u06D5\u062A\u0643\u06D5 \u0626\u0627\u0644\u0645\u0627\u0634\u062A\u06C7\u0631\u06C7\u0634",
      system: "\u0633\u0649\u0633\u062A\u06D0\u0645\u0627"
    },
    commandPalette: {
      back: "\u0642\u0627\u064A\u062A\u0649\u0634",
      close: "\u062A\u0627\u0642\u0627\u0634",
      noData: "\u0633\u0627\u0646\u0644\u0649\u0642 \u0645\u06D5\u0644\u06C7\u0645\u0627\u062A \u064A\u0648\u0642",
      noMatch: "\u0645\u0627\u0633 \u0643\u06D0\u0644\u0649\u062F\u0649\u063A\u0627\u0646 \u0633\u0627\u0646\u0644\u0649\u0642 \u0645\u06D5\u0644\u06C7\u0645\u0627\u062A \u064A\u0648\u0642",
      placeholder: "\u0628\u06C7\u064A\u0631\u06C7\u0642 \u0643\u0649\u0631\u06AF\u06C8\u0632\u06C8\u06AD \u064A\u0627\u0643\u0649 \u0626\u0649\u0632\u062F\u06D5\u06AD..."
    },
    contentSearch: {
      links: "\u0626\u06C7\u0644\u0627\u0646\u0645\u0649\u0644\u0627\u0631",
      theme: "\u062A\u06D0\u0645\u0627"
    },
    contentSearchButton: {
      label: "\u0626\u0649\u0632\u062F\u06D5\u0634"
    },
    contentToc: {
      title: "\u0645\u06D5\u0632\u0645\u06C7\u0646"
    },
    dashboardSearch: {
      theme: "\u062A\u06D0\u0645\u0627"
    },
    dashboardSearchButton: {
      label: "\u0626\u0649\u0632\u062F\u06D5\u0634"
    },
    dashboardSidebarCollapse: {
      collapse: "\u062A\u0627\u0631\u0627\u064A\u062A\u0649\u0634",
      expand: "\u0643\u06D0\u06AD\u06D5\u064A\u062A\u0649\u0634"
    },
    dashboardSidebarToggle: {
      close: "\u062A\u0627\u0642\u0627\u0634",
      open: "\u0626\u06D0\u0686\u0649\u0634"
    },
    error: {
      clear: "\u062A\u0627\u0632\u0649\u0644\u0627\u0634"
    },
    fileUpload: {
      removeFile: "{filename} \u0626\u06C6\u0686\u06C8\u0631\u06C8\u0634"
    },
    header: {
      close: "\u062A\u0627\u0642\u0627\u0634",
      open: "\u0626\u06D0\u0686\u0649\u0634"
    },
    inputMenu: {
      create: '"{label}" \u0646\u0649 \u0642\u06C7\u0631\u06C7\u0634',
      noData: "\u0633\u0627\u0646\u0644\u0649\u0642 \u0645\u06D5\u0644\u06C7\u0645\u0627\u062A \u064A\u0648\u0642",
      noMatch: "\u0645\u0627\u0633 \u0643\u06D0\u0644\u0649\u062F\u0649\u063A\u0627\u0646 \u0633\u0627\u0646\u0644\u0649\u0642 \u0645\u06D5\u0644\u06C7\u0645\u0627\u062A \u064A\u0648\u0642"
    },
    inputNumber: {
      decrement: "\u0626\u0627\u0632\u0627\u064A\u062A\u0649\u0634",
      increment: "\u0643\u06C6\u067E\u06D5\u064A\u062A\u0649\u0634"
    },
    modal: {
      close: "\u062A\u0627\u0642\u0627\u0634"
    },
    pricingTable: {
      caption: "\u0628\u0627\u06BE\u0627 \u062C\u06D5\u062F\u06CB\u0649\u0644\u0649"
    },
    prose: {
      codeCollapse: {
        closeText: "\u062A\u0627\u0631\u0627\u064A\u062A\u0649\u0634",
        name: "\u0643\u0648\u062F",
        openText: "\u0643\u06D0\u06AD\u06D5\u064A\u062A\u0649\u0634"
      },
      collapsible: {
        closeText: "\u064A\u0648\u0634\u06C7\u0631\u06C7\u0634",
        name: "\u062E\u0627\u0633\u0644\u0649\u0642\u0644\u0627\u0631",
        openText: "\u0643\u06C6\u0631\u0633\u0649\u062A\u0649\u0634"
      },
      pre: {
        copy: "\u0643\u06C6\u0686\u06C8\u0631\u06C8\u0634"
      }
    },
    selectMenu: {
      create: '"{label}" \u0646\u0649 \u0642\u06C7\u0631\u06C7\u0634',
      noData: "\u0633\u0627\u0646\u0644\u0649\u0642 \u0645\u06D5\u0644\u06C7\u0645\u0627\u062A \u064A\u0648\u0642",
      noMatch: "\u0645\u0627\u0633 \u0643\u06D0\u0644\u0649\u062F\u0649\u063A\u0627\u0646 \u0633\u0627\u0646\u0644\u0649\u0642 \u0645\u06D5\u0644\u06C7\u0645\u0627\u062A \u064A\u0648\u0642",
      search: "\u0626\u0649\u0632\u062F\u06D5\u0634..."
    },
    slideover: {
      close: "\u062A\u0627\u0642\u0627\u0634"
    },
    table: {
      noData: "\u0633\u0627\u0646\u0644\u0649\u0642 \u0645\u06D5\u0644\u06C7\u0645\u0627\u062A \u064A\u0648\u0642"
    },
    toast: {
      close: "\u062A\u0627\u0642\u0627\u0634"
    }
  }
});
